/**
 * Les clés de stockage des fichiers, dans le compartiment `documents`.
 *
 * Le premier dossier dit à qui appartient le fichier ; les règles de Storage de
 * db/002-referentiels.sql s'appuient dessus. Ne pas en changer la forme sans
 * changer les règles.
 */

export const COMPARTIMENT = 'documents';

/** Durée de vie d'une adresse signée, en secondes. */
export const DUREE_ADRESSE_SECONDES = 10 * 60;

const LONGUEUR_MAX_NOM = 100;

/**
 * Un nom de fichier sûr pour une clé de stockage : les accents perdent leur
 * diacritique, tout ce qui n'est pas `[a-zA-Z0-9._-]` devient « - ».
 * Le nom d'origine, lui, est gardé tel quel dans la ligne de métadonnées.
 */
export function nettoyerNomFichier(nom: string): string {
  const propre = nom
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9._-]/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^[-.]+|-+$/g, '');
  if (propre.length === 0) return 'fichier';
  if (propre.length <= LONGUEUR_MAX_NOM) return propre;
  /* On coupe le début plutôt que l'extension : « .pdf » dit comment l'ouvrir. */
  const point = propre.lastIndexOf('.');
  const extension = point > 0 && propre.length - point <= 10 ? propre.slice(point) : '';
  return propre.slice(0, LONGUEUR_MAX_NOM - extension.length) + extension;
}

/** `entreprises/<entreprise_id>/<uuid>-<nom>` */
export function cheminDocumentEntreprise(entrepriseId: string, nom: string, uuid: string): string {
  return `entreprises/${entrepriseId}/${uuid}-${nettoyerNomFichier(nom)}`;
}

/** `conformite/<partenaire_id>/<uuid>-<nom>` */
export function cheminConformite(partenaireId: string, nom: string, uuid: string): string {
  return `conformite/${partenaireId}/${uuid}-${nettoyerNomFichier(nom)}`;
}

/** `chantiers/<chantier_id>/<etape_id>/<uuid>-<nom>` — règles de db/003-chantiers.sql. */
export function cheminPreuve(
  chantierId: string,
  etapeId: string,
  nom: string,
  uuid: string
): string {
  return `chantiers/${chantierId}/${etapeId}/${uuid}-${nettoyerNomFichier(nom)}`;
}

/** `sav/<ticket_id>/<uuid>-<nom>` — règles de db/007-sav.sql. */
export function cheminPreuveSav(ticketId: string, nom: string, uuid: string): string {
  return `sav/${ticketId}/${uuid}-${nettoyerNomFichier(nom)}`;
}
